export default __webpack_public_path__ + "static/media/outlier_logo.1600c8af.svg";